import { enableProvider } from "@/pixels/runner";
import pixels from "@/pixels";

jest.mock("@/pixels/runner", () => ({
  enableProvider: jest.fn().mockImplementation((provider, callback) => {
    callback();
  }),
  run: jest.fn()
}));
jest.mock("@/bus");
describe("Pixels", () => {
  beforeEach(() => {
    jest.clearAllMocks();
  });

  describe("initProvider", () => {
    it("should enable provider and process queue if it exists", () => {
      const provider = {
        queue: [jest.fn(), jest.fn()]
      };

      const Vue = {
        $log: {
          info: jest.fn()
        }
      };

      pixels.initProvider("test", provider, Vue);

      expect(enableProvider).toHaveBeenCalledTimes(1);
      expect(provider.queue[0]).toHaveBeenCalledTimes(1);
      expect(provider.queue[1]).toHaveBeenCalledTimes(1);
      expect(Vue.$log.info).toHaveBeenCalled();
    });
  });

  it("should not process queue when provider queue is empty", () => {
    const provider = {
      queue: []
    };

    const Vue = {
      $log: {
        info: jest.fn()
      }
    };

    pixels.initProvider("test", provider, Vue);

    expect(enableProvider).toHaveBeenCalledTimes(1);
    expect(Vue.$log.info).toHaveBeenCalledTimes(1);
  });

  it("should not process queue when provider queue is not defined", () => {
    const provider = {};

    const Vue = {
      $log: {
        info: jest.fn()
      }
    };

    pixels.initProvider("test", provider, Vue);

    expect(enableProvider).toHaveBeenCalledTimes(1);
    expect(Vue.$log.info).toHaveBeenCalledTimes(1);
  });
});
